import React, { memo, useState } from 'react';

import makeStyles from '@material-ui/core/styles/makeStyles';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';

const HMapCheckbox = ({
  id,
  label,
  onClick,
  defaultChecked,
  fontSize = 'default',
  width = '100%',
}) => {
  const classes = useStyles({ fontSize, width });
  const [checked, setChecked] = useState(defaultChecked || false);

  const handleChange = () => {
    const newValue = !checked;
    setChecked(newValue);

    if (onClick) {
      const props = {
        ...(id && { id })
      };

      return onClick(newValue, { ...props });
    }
  };

  return (
    <div className={classes.root}>
      <FormControlLabel
        control={<Checkbox checked={checked} onChange={handleChange} />}
        title={label}
        label={label}
      />
    </div>
  );
};

export default memo(HMapCheckbox);

const useStyles = makeStyles(() => ({
  root: {
    width: '100%',
    height: '56px',
    boxSizing: 'border-box',
    display: 'flex',
    backgroundColor: '#FFFFFF',
    padding: '8px',
    borderRadius: '5px',

    '& .MuiFormControlLabel-root': {
      width: '100%',
      margin: 0,
      gap: '4px'
    },

    '& .MuiCheckbox-root': {
      flexShrink: 0,
      padding: '4px'
    },

    '& .MuiFormControlLabel-label': {
      fontSize: (props) => {
        const sizes = {
          small: '12px',
          default: '1rem',
          large: '1.2rem'
        };

        return sizes[props.fontSize] || sizes.default;
      },
      width: (props) => props.width,
      minWidth: 0,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    }
  }
}));
